import { StyledMessageBox } from './style';
import { MessageBoxProps } from './types';

export const MessageBox: React.FC<MessageBoxProps> = ({
  title,
  text,
  fontFamily,
  borderColor,
}) => (
  <StyledMessageBox fontFamily={fontFamily} borderColor={borderColor}>
    <h2>{title}</h2>
    <p>{text}</p>
  </StyledMessageBox>
);
